import Chip from '@mui/material/Chip'
import { useTranslation } from 'react-i18next'

import { getBadgeData } from 'lib/utility/GetBadgeData'

const StatusBadge = ({
  blocked,
  status,
  type,
}: {
  blocked: boolean
  status: string
  type: string
}) => {
  const badgeData = getBadgeData(blocked, status, type)

  const { t } = useTranslation()

  if (badgeData) {
    return (
      <Chip
        size="small"
        color={badgeData.color}
        label={t(`participant.status.${badgeData.text}`)}
      />
    )
  }
  return <></>
}

export default StatusBadge
